<template>
  <div style="position: fixed; left: 0; top: 0; right: 0; bottom: 0; z-index: 999">
    <v-main class="page-mission page-mission-main has-ticket">
      <v-layout fill-height column class="mission-main-contents">
        <v-container fluid class="mission-main-header">
          <h4 class="mission-main-title">
            🔎 내 마음, 나도 잘 모를 땐
          </h4>
          <section class="d-flex" id="missionTutorialTarget02">
            <MissionCard v-bind="{ type: 'weather', write: false, typeCode: '' }" :busy="false" />
            <MissionCard v-bind="{ type: 'mindnote', write: false }" :busy="false" />
          </section>
        </v-container>
        <article class="mission-main-body" id="missionTutorialTarget03">
          <v-container fluid>

            <MissionAchievement :value="0" />

            <article class="mission-solution mt-3">
              <section class="mission-solution-content">
                <div class="mission-solution-header">
                  <h4 class="mission-solution-title">후유와 미션을 함께한 지</h4>
                  <div class="d-flex flex-grow-1 justify-end fs-15 fw-500">
                    <b class="badge-today">TODAY</b>
                    <b>1</b>일차
                  </div>
                </div>
                <div class="mission-date-groups ms-0">
                  <button class="mission-date-item selected">1</button>
                  <button class="mission-date-item">2</button>
                  <button class="mission-date-item">3</button>
                  <button class="mission-date-item">4</button>
                  <button class="mission-date-item">5</button>
                  <button class="mission-date-item">6</button>
                </div>
              </section>
              <section class="mission-solution-content">
                <div class="mission-solution-header">
                  <h4 class="mission-solution-title">1일차 미션</h4>
                </div>
              </section>
              <div class="solution-list">
                <template v-for="(solution, index) in solutions">
                  <div v-ripple class="solution-list-item solution-list-item--fixed" :key="index">
                    <v-avatar>
                      <v-img :src="getImage(helpfulIcon(solution.helpful))" />
                    </v-avatar>
                    <div class="unit-info">
                      <b class="unit-name">{{ solution.unitNm }}</b>
                      <span class="unit-type">{{ solution.unitTypeNm }} + {{solution.unitTypeCnt - 1}}</span>
                    </div>
                  </div>
                </template>
              </div>
            </article>

          </v-container>
        </article>
      </v-layout>
      <!-- // 티켓이 없는 경우 -->
      <BottomMenu id="missionTutorialTarget01" style="z-index: 1 !important; bottom: 50px;" :current="2" />
    </v-main>
    <!-- step 1 -->
    <v-overlay opacity="0.75" color="#000">
        <div :class="{ 'show' : step === 1 }" :style="{ left: `${coachMarks[0].offset.x}px`, top: `${coachMarks[0].offset.y}px` }" data-tutorial="step1">
          <div class="mission-tutorial-text">
            <strong>미션</strong> 카테고리를 소개할게요.
          </div>
          <div class="mission-tutorial-dashed">
            <v-img :src="getImage('tutorial/mission/tutorial_mission_01.svg')" />
          </div>
        </div>
        <!-- step 2 -->
        <div :class="{ 'show' : step === 2 }" :style="{ left: `${coachMarks[1].offset.x}px`, top: `${coachMarks[1].offset.y}px` }" data-tutorial="step2">
          <div class="mission-tutorial-text">
            내 마음을 들여다볼 수 있는 무료 미션과
          </div>
          <section class="mission-tutorial-dashed">
            <MissionCard v-bind="{ type: 'weather', write: false, typeCode: '' }" :busy="false" />
            <MissionCard v-bind="{ type: 'mindnote', write: false }" :busy="false" />
          </section>
        </div>
        <!-- step 3 -->
        <div :class="{ 'show' : step === 3 }" :style="{ left: `${coachMarks[2].offset.x}px`, top: `${coachMarks[2].offset.y}px` }" data-tutorial="step3">
          <div class="mission-tutorial-text">
            티켓을 시작하면<br />
            매일 마음을 단련할 수 있는<br />
            <span style="color: #FE52A7">일차별 미션</span>이 있어요!
          </div>
          <article class="mission-main-body">
            <v-container fluid>

              <MissionAchievement :value="0" />

              <article class="mission-solution mt-3">
                <section class="mission-solution-content">
                  <div class="mission-solution-header">
                    <h4 class="mission-solution-title">후유와 미션을 함께한 지</h4>
                    <div class="d-flex flex-grow-1 justify-end fs-15 fw-500">
                      <b class="badge-today">TODAY</b>
                      <b>1</b>일차
                    </div>
                  </div>
                  <div class="mission-date-groups ms-0">
                    <button class="mission-date-item selected">1</button>
                    <button class="mission-date-item">2</button>
                    <button class="mission-date-item">3</button>
                    <button class="mission-date-item">4</button>
                    <button class="mission-date-item">5</button>
                    <button class="mission-date-item">6</button>
                  </div>
                </section>
                <section class="mission-solution-content">
                  <div class="mission-solution-header">
                    <h4 class="mission-solution-title">1일차 미션</h4>
                  </div>
                </section>
                <div class="solution-list">
                  <template v-for="(solution, index) in solutions">
                    <div @click.prevent class="solution-list-item solution-list-item--fixed" :key="index">
                      <v-avatar>
                        <v-img :src="getImage(helpfulIcon(solution.helpful))" />
                      </v-avatar>
                      <div class="unit-info">
                        <b class="unit-name">{{ solution.unitNm }}</b>
                        <span class="unit-type">{{ solution.unitTypeNm }} + {{solution.unitTypeCnt - 1}}</span>
                      </div>
                    </div>
                  </template>
                </div>
              </article>

            </v-container>
          </article>
        </div>
        <!-- step 4 -->
        <div :class="{ 'show' : step === 4 }" :style="{ left: `${coachMarks[3].offset.x}px`, top: `${coachMarks[3].offset.y}px` }" data-tutorial="step4">
          <div class="mission-tutorial-text">
            티켓별 미션 수행일이 주어져요.
          </div>
          <div class="mission-tutorial-cont">
            <article class="mission-solution" style="position: relative; width: 100%">
              <section class="mission-solution-content">
                <div class="mission-solution-header">
                  <h4 class="mission-solution-title">후유와 미션을 함께한 지</h4>
                  <div class="d-flex flex-grow-1 justify-end fs-15 fw-500">
                    <b class="badge-today">TODAY</b>
                    <b>1</b>일차
                  </div>
                </div>
                <div class="mission-date-groups ms-0">
                  <button class="mission-date-item selected">1</button>
                  <button class="mission-date-item">2</button>
                  <button class="mission-date-item">3</button>
                  <button class="mission-date-item">4</button>
                  <button class="mission-date-item">5</button>
                  <button class="mission-date-item">6</button>
                </div>
              </section>
              <div class="mission-tutorial-img">
                <v-img :src="getImage('tutorial/mission/tutorial_mission_04.svg')" />
              </div>
            </article>
          </div>
        </div>
        <!-- step 5 -->
        <div :class="{ 'show' : step === 5 }" :style="{ left: `${coachMarks[4].offset.x}px`, top: `${coachMarks[4].offset.y}px` }" data-tutorial="step5">
          <div class="mission-tutorial-text">
            일차별로 오늘의 미션이 주어져요.
          </div>
          <div class="mission-tutorial-cont">
            <article class="mission-solution">
              <section class="mission-solution-content">
                <div class="mission-solution-header">
                  <h4 class="mission-solution-title">1일차 미션</h4>
                </div>
              </section>
              <div class="solution-list">
                <template v-for="(solution, index) in solutions">
                  <div v-if="index < 3" v-ripple class="solution-list-item solution-list-item--fixed" :key="index">
                    <v-avatar>
                      <v-img :src="getImage(helpfulIcon(solution.helpful))" />
                    </v-avatar>
                    <div class="unit-info">
                      <b class="unit-name">{{ solution.unitNm }}</b>
                      <span class="unit-type">{{ solution.unitTypeNm }} + {{solution.unitTypeCnt - 1}}</span>
                    </div>
                  </div>
                </template>
              </div>
            </article>
          </div>
        </div>
        <!-- step 6 -->
        <div :class="{ 'show' : step === 6 }" :style="{ left: `${coachMarks[5].offset.x}px`, top: `${coachMarks[5].offset.y}px` }" data-tutorial="step6">
          <div class="mission-tutorial-text">
            나의 마음을 위해<br />
            꾸준히 미션을 수행해 봐요!
          </div>
          <div class="mission-tutorial-dashed">
            <MissionAchievement :value="50" />
          </div>
        </div>
      <div class="control-wrapper"
           v-touch="{ left: () => next('left'), right: () => prev('right') }">

        <div class="coach-bottom-controller">
          <div class="swiper-pagination" slot="pagination">
            <span v-for="i in 6" :key="i"
                  class="swiper-pagination-bullet"
                  :class="{ 'swiper-pagination-bullet-active' : i === step }"
            />
          </div>
          <v-btn v-if="step === (coachMarks.length)" text @click="close">닫기</v-btn>
        </div>
      </div>
    </v-overlay>
  </div>
</template>

<script>
import BottomMenu from '@/components/layout/BottomMenu.vue'
import MissionCard from '@/components/mission/Card.vue'
import MissionAchievement from '@/components/mission/Achievement.vue'
import {mixinAuth} from "@/mixins";
import store from "@/store";
// import MissionSolutionList from '@/components/mission/SolutionList.vue'

export default {
  name: 'pubMissionMain',
  components: {
    MissionCard,
    MissionAchievement,
    // MissionSolutionList,
    BottomMenu
  },
  mixins: [mixinAuth],
  data: () => ({
    step: 0,
    solutions: [
      {
        unitNm: "당신의 빌런은 번아웃?️",
        unitType: "09",
        unitTypeNm: "워크시트형",
        unitTypeCnt: 4,
        helpful: "01,04"
      },
      {
        unitNm: "휴식이 필요한 순간",
        unitType: "01",
        unitTypeNm: "몸 알아차리기",
        unitTypeCnt: 3,
        helpful: "04,05"
      },
      {
        unitNm: "나와 화해하기",
        unitType: "07",
        unitTypeNm: "몰입훈련형",
        unitTypeCnt: 1,
        helpful: "02,05"
      },
      {
        unitNm: "나와 화해하기",
        unitType: "07",
        unitTypeNm: "몰입훈련형",
        unitTypeCnt: 1,
        helpful: "02,05"
      },
      {
        unitNm: "나와 화해하기",
        unitType: "07",
        unitTypeNm: "몰입훈련형",
        unitTypeCnt: 1,
        helpful: "02,05"
      },
      {
        unitNm: "나와 화해하기",
        unitType: "07",
        unitTypeNm: "몰입훈련형",
        unitTypeCnt: 1,
        helpful: "02,05"
      },
      {
        unitNm: "나와 화해하기",
        unitType: "07",
        unitTypeNm: "몰입훈련형",
        unitTypeCnt: 1,
        helpful: "02,05"
      },
      {
        unitNm: "나와 화해하기",
        unitType: "07",
        unitTypeNm: "몰입훈련형",
        unitTypeCnt: 1,
        helpful: "02,05"
      },
      {
        unitNm: "나와 화해하기",
        unitType: "07",
        unitTypeNm: "몰입훈련형",
        unitTypeCnt: 1,
        helpful: "02,05"
      },
      {
        unitNm: "나와 화해하기",
        unitType: "07",
        unitTypeNm: "몰입훈련형",
        unitTypeCnt: 1,
        helpful: "02,05"
      },
      {
        unitNm: "나와 화해하기",
        unitType: "07",
        unitTypeNm: "몰입훈련형",
        unitTypeCnt: 1,
        helpful: "02,05"
      }
    ],
    coachMarks: [
      { step: 0, offsetTarget: '#missionTutorialTarget01', offset: { x: 0, y: 0 } },
      { step: 1, offsetTarget: '#missionTutorialTarget02', offset: { x: 0, y: 0 } },
      { step: 2, offsetTarget: '#missionTutorialTarget03', offset: { x: 0, y: 0 } },
      { step: 3, offsetTarget: '#missionTutorialTarget03', offset: { x: 0, y: 0 } },
      { step: 4, offsetTarget: '#missionTutorialTarget03', offset: { x: 0, y: 0 } },
      { step: 5, offsetTarget: '#missionTutorialTarget03', offset: { x: 0, y: 0 } },
    ]
  }),
  computed: {
    item () {
      return this.coachMarks.find(v => v.step === this.step)
    }
  },
  created () {
    if (!this.memberInfo.missionTutorial) {
      store.dispatch('checkMissionTutorial')
          .then(res => {
            if (res.success) {
              store.commit('setMemberInfo', {missionTutorial: true})
            } else {
              console.log(res.msg)
            }
          })
    }
  },
  activated () {},
  mounted () {
    this.step = 1
    window.addEventListener('resize', this.setOffsetTarget)
    this.$nextTick(() => {
      this.setOffsetTarget()
    })
  },
  methods: {
    helpfulIcon (helpful) {
      let str = helpful.substr(0, 2)
      return 'ic_condition_white_' + str + '.svg'
    },
    prev () {
      if (this.step <= 1) return false
      else this.step = this.step - 1
    },
    next () {
      if (this.step < this.coachMarks.length) this.step++
    },
    close () {
      this.$router.replace({ name: '퍼블_미션' })
    },
    setOffsetTarget () {
      this.coachMarks.forEach((val, i) => {
        this.coachMarks[i].offset = document.querySelector(val.offsetTarget).getBoundingClientRect()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.coach-bottom-controller::v-deep {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
  height: 50px;
  padding-bottom: calc(5px + calc(#{var(--system-bottom-height)} *.5));
  background-color: #333;
  >.v-btn {
    position: absolute;
    right: 0;
  }
  .swiper-pagination {
    display: flex;
    align-items: center;
    justify-content: center;
    &-bullet {
      display: block;
      width: 10px;
      height: 10px;
      margin: 0 3px;
      background-color: #fff;
      border-radius: 50em;
      &-active {
        background: var(--v-primary-base);
      }
    }
  }
}
.control-wrapper {
  position: fixed;
  left: 0;
  top: calc(var(--system-bar-height) * 1);
  right: 0;
  bottom: 0;
  width: 100vw;
  height: calc(100vh - var(--system-bar-height));
  z-index: 9999;
}
[data-tutorial] {
  opacity: 0;
  transition: opacity ease-in-out 0.3s;
  &.show {
    opacity: 1;
  }
}
[data-tutorial="step1"] {
  position: fixed;
  width: 100dvw;
  margin-top: -80px;
  text-align: center;
  .mission-tutorial-text {
    margin-bottom: 40px;
  }
  .mission-tutorial-dashed {
    display: inline-block;
  }
}
[data-tutorial="step2"] {
  position: fixed;
  width: calc(100dvw - 40px);
  margin-top: -50px;
  .mission-tutorial-text {
    margin-bottom: 10px;
  }
  .mission-tutorial-dashed {
    display: flex;
    padding: 13px 7px;
    margin: 0 -9px;
    .card-mission {
      height: 95px;
    }
  }
}
[data-tutorial="step3"] {
  position: fixed;
  width: 100dvw;
  //margin-top: -115px;
  margin-top: -115px;
  .mission-tutorial-text {
    margin-bottom: 42px;
  }
  .mission-main-body {
    color: #333;
  }
}
[data-tutorial="step4"] {
  position: fixed;
  width: 100dvw;
  margin-top: -35px;
  .mission-tutorial-text {
    margin-bottom: 30px;
  }
  .mission-tutorial-cont {
    padding: 0 20px;
  }
  .mission-tutorial-img {
    position: absolute;
    top: 105px;
    left: 50%;
    z-index: 1;
    transform: translateX(-50%);
  }
  .mission-solution {
    position: relative;
    color: #333;
    &::after {
      content: "";
      display: block;
      position: absolute;
      z-index: 0;
      left: 0;
      right: 0;
      width: 100%;
      height: 17px;
      background: linear-gradient(180deg, #FFFFFF 13.64%, #DADADA 70.15%, #7A7A7A 145.45%);
    }
  }
}
[data-tutorial="step5"] {
  position: fixed;
  width: 100dvw;
  margin-top: -35px;
  .mission-tutorial-text {
    margin-bottom: 30px;
  }
  .mission-tutorial-cont {
    padding: 0 20px;
  }
  .mission-solution {
    position: relative;
    color: #333;
  }
}
[data-tutorial="step6"] {
  position: fixed;
  width: 100dvw;
  margin-top: -35px;
  .mission-tutorial-text {
    margin-bottom: 25px;
  }
  .mission-tutorial-dashed {
    padding: 8px;
    margin: 0 12px;
    color: #333;
  }
}
.mission-tutorial-text {
  color: #fff;
  text-align: center;
  font-weight: 500;
  font-size: 18px;
  line-height: 137%;
  letter-spacing: -0.03em;
  vertical-align: middle;
  strong {
    font-weight: 600;
    color: #EC5FA5;
  }
}
.mission-tutorial-dashed {
  padding: 4px;
  border: 2px dashed #BB9DEF;
  border-radius: 10px;
  svg {
    vertical-align: top;
  }
}
.solution-list {
  overflow: hidden !important;
}
</style>
